import React from 'react';
import { Segment, Table, Header, Icon, Popup } from 'semantic-ui-react';
import { IconHeader } from '../util/css';
import { getLeaseholderName } from '../util/util';

export default class LeaseholderDetails extends React.Component {
    render() {
        const { leaseholder, addresses, contacts } = this.props;
        return (
            <div>
                <Header as="h1">Zakupci</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            O zakupcu
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon link circular basic floated="right" name="arrow left" onClick={this.props.switchToTable} />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                        </Header>
                    </Segment>
                    <Segment>
                        <Table celled>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Ime</b></Table.Cell>
                                    <Table.Cell>{getLeaseholderName(leaseholder)}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Članica</b></Table.Cell>
                                    <Table.Cell>{leaseholder.organizationalUnit ? leaseholder.organizationalUnit.name : null}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Napomena</b></Table.Cell>
                                    <Table.Cell>{leaseholder.comment}</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Tip entiteta</b></Table.Cell>
                                    <Table.Cell>{leaseholder.entityType.name}</Table.Cell>
                                </Table.Row>

                                {leaseholder.physicalEntity &&
                                <Table.Row>
                                    <Table.Cell textAlign="right"><b>Ime i prezime</b></Table.Cell>
                                    <Table.Cell>{leaseholder.physicalEntity.firstName} {leaseholder.physicalEntity.lastName}</Table.Cell>
                                </Table.Row>
                                }

                                {leaseholder.legalEntity &&
                                    <Table.Row>
                                        <Table.Cell textAlign="right"><b>ID Broj</b></Table.Cell>
                                        <Table.Cell>{leaseholder.legalEntity.idNumber}</Table.Cell>
                                    </Table.Row>
                                }
                            </Table.Body>
                        </Table>
                    </Segment>

                    <Segment>
                        <Header as="h3">Kontakti</Header>
                        <Table celled>
                            <Table.Header>
                                <Table.HeaderCell>Tip kontakta</Table.HeaderCell>
                                <Table.HeaderCell>Kontakt</Table.HeaderCell>
                            </Table.Header>
                            <Table.Body>
                                {contacts.map(el =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell>
                                            {!!el.contactType && el.contactType.name}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {el.value}
                                        </Table.Cell>
                                    </Table.Row>))}
                            </Table.Body>
                        </Table>
                    </Segment>

                    <Segment>
                        <Header as="h3">Adrese</Header>
                        <Table celled>
                            <Table.Header>
                                <Table.HeaderCell>Ulica</Table.HeaderCell>
                                <Table.HeaderCell>Mjesto</Table.HeaderCell>
                            </Table.Header>
                            <Table.Body>
                                {addresses.map(el =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell>
                                            {el.street}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {!!el.place.municipality && el.place.municipality.name}, {!!el.place.canton && el.place.canton.name}, {!!el.place.entity && el.place.entity.name}, {!!el.place.country && el.place.country.name}
                                        </Table.Cell>
                                    </Table.Row>))
                                }
                            </Table.Body>
                        </Table>
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Leaseholder/LeaseholderDetails.js